import React, { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import Loading from "views/lib/Loading";
import filterTypes from "data/filter-types";
import { translationAdd, translationGetSearch } from "actions/translation/requests";
import { languageGetSearch } from "actions/language/requests";

const MessagesModal = ({
                         onSuccess,
                         messageId,
                         module,

                         translationAdd,
                         translationGetSearch,
                         translations,

                         languageGetSearch,
                         languages,

                         translationsLoading,
                         languagesLoading,
                       }) => {
  const [data, setData] = useState([]);

  const handleChange = (ev, languageId) => {
    const currentTranslationIndex = data.findIndex(translation => translation.language === languageId && messageId === translation.key);
    const newData = [...data];
    if (currentTranslationIndex === -1) {
      newData.push({
        key: messageId,
        language: languageId,
        module,
        value: ev.target.value
      });
    } else {
      newData[currentTranslationIndex].value = ev.target.value;
    }
    setData(newData);
  };

  const handleSubmit = ev => {
    ev.preventDefault();
    data.forEach(item => {
      translationAdd(item, () => {
      });
    });
    onSuccess();
  };

  useEffect(() => {
    if (!languages.length) {
      languageGetSearch(0, 10000, undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    translationGetSearch(0, 10000, undefined, [{
      fieldName: "key",
      fieldValue: messageId,
      searchOperation: filterTypes.EQUALS.value
    }, {
      fieldName: "module",
      fieldValue: module,
      searchOperation: filterTypes.EQUALS.value
    }]);
  }, [messageId, module, translationGetSearch]);

  useEffect(() => {
    setData(translations.content);
  }, [translations]);

  return (
    <div className="card-body">
      <Loading state={translationsLoading || languagesLoading}/>

      <h4>Message: {messageId}</h4>
      <h4>Module: {module}</h4>
      <hr/>
      <br/>

      <form>
        {languages.map(item => {
          const currentTranslation = data.find(translation => translation.language === item.id && messageId === translation.key);
          return (
            <div className="input-group mb-3" key={item.id}>
            <span className="input-group-text" style={{ width: 300 }}>
              <img alt="" src={item.flag} style={{
                maxHeight: 24,
                maxWidth: 24,
                height: "auto",
                width: "auto",
                marginRight: 4
              }}/> {item.name}({item.id})
            </span>
              <textarea
                className="form-control"
                onChange={ev => handleChange(ev, item.id)}
                value={currentTranslation && currentTranslation.value ? currentTranslation.value : ""}
              />
            </div>
          );
        })}

        <div className="text-end">
          <button
            onClick={handleSubmit}
            className="btn btn-success"
          >
            <FontAwesomeIcon icon={faSave}/> Save
          </button>
        </div>
      </form>
    </div>
  );
};

const mapStateToProps = state => ({
  translations: state.translation.list,
  translationsLoading: state.translation.loading,
  languages: state.language.list.content,
  languagesLoading: state.language.loading,
});

const mapStateToDispatch = dispatch => ({
  translationAdd: bindActionCreators(translationAdd, dispatch),
  translationGetSearch: bindActionCreators(translationGetSearch, dispatch),
  languageGetSearch: bindActionCreators(languageGetSearch, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(MessagesModal);



// WEBPACK FOOTER //
// ./src/views/pages/Translation/MessagesModal.js